export class DuplicateWorkOrderError extends Error {
	existingWorkOrderId: string;
	existingOrderNumber: number;

	constructor(existingWorkOrderId: string, existingOrderNumber: number) {
		super('A work order with identical details already exists');
		this.name = 'DuplicateWorkOrderError';
		this.existingWorkOrderId = existingWorkOrderId;
		this.existingOrderNumber = existingOrderNumber;
	}
}
